import style from '../CSS/RoundVideoResult.module.css'

const Card = ({number, title}) => {
    return (
        <>
            <div className={style.card}>
                <div className={style.card__title}>{number}<br/> Videos</div>
                <div className={style.card__footer}>{title}</div>
            </div>
        </>
    );
};

export default Card;